import { Navigate, useLocation } from "react-router-dom";

export const ProtectedRoute = ({ user, children }) => {
  const location = useLocation();
  const sliceLocation = location?.pathname?.split("/")?.slice(0, 3)?.join("/");
  return !user ? <Navigate to={sliceLocation} replace /> : children;
};